<template>
  <div class="main-bg">
    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      :controls="carouselEnabled"
      :indicators="carouselEnabled"
      fade
      background="#ababab"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <b-carousel-slide
        v-for="(imgUrl, iIdx) in imagesUrls" v-bind:key="iIdx"
        :img-src="imgUrl"
      />
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: 'Banner',

  props: {
    imagesUrls: {
      required: true,
      type: Array
    }
  },

  data() {
    return {
      slide: 0,
      sliding: null
    }
  },

  methods: {
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    }
  },

  computed: {
    carouselEnabled() {
      return this.imagesUrls.length > 1;
    }
  }
}
</script>

<style lang="scss">
.main-bg {
  height: 95vh;

  @media (max-width: 768px) {
    height: 50vh !important;
  }
}

.carousel-item img {
  height:90vh!important;

  @media (max-width: 768px) {
    height: 40vh !important;
  }
}
</style>
